import request from '@/CommonDP/utils/request';

export default {
  queryTemplate(dicCode, keyWord, pId) {
    return request.get(`/sysReviewPoint/list?dicCode=${dicCode}&keyWord=${keyWord}&pId=${pId}`)
      .then(res => res);
  },
  addDicMessage(params) {
    return request.post('/sysReviewPoint/add', params)
      .then(res => res);
  },
  deleteTempClass(params) {
    return request.post('/sysReviewPoint/delete', params)
      .then(res => res);
  },
  updateTempClass(params) {
    return request.post('/sysReviewPoint/update', params)
      .then(res => res);
  },
  moveTempLeft(id, moveFlag) {
    return request.post(`/sysReviewPoint/move/upOrDown?id=${id}&moveFlag=${moveFlag}`)
      .then(res => res);
  },
  upOrDownTempLeft(id, moveFlag) {
    return request.post(`/sysReviewPoint/grade/upOrDown?id=${id}&moveFlag=${moveFlag}`)
      .then(res => res);
  },
  // 导入数据
  sysReviewPointImport (params) {
    return request.post(`/sysReviewPoint/import`, params);
  }
};
